import styled from 'styled-components'
import { cssMediaQueryBreakpoints } from '../../../config/breakpoints'

export const PageHeading = styled.h1`
    ${cssMediaQueryBreakpoints.medium} {
        font-size: 14px;
    }

    font-size: 15px;
    font-weight: 500;
    color: ${p => p.theme.pageHeadingColor};
    margin-top: 15px;
    margin-bottom: 10px;
    font-family: inherit;
    user-select: none;
`
